/* eslint-disable camelcase */
import { gql } from '@apollo/client'

export type {
  CompanySeasons,
  CompanySeasonsVariables,
  CompanySeasons_seasons_Seasons_results_Season as CompanySeason,
  Season_season_Season_seasonFields_SeasonField as SeasonField,
} from './types/season.graphql'

export const COMPANY_SEASONS = gql`
  query CompanySeasons($companyId: Int!) {
    seasons(companyId: $companyId) {
      results {
        id
        name
        startDate
        seasonFields {
          lots {
            id
          }
          field {
            id
            name
          }
        }
      }
    }
  }
`

export type {
  Season as SeasonData,
  SeasonVariables,
  Season_season_Season as Season,
  Season_season_Season_seasonFields_SeasonField_lots_LotV2 as SeasonLot,
  Season_season_Season_seasonFields_SeasonField_field_Field_weather_Weather_days_WeatherDay as WeatherDay,
  Season_season_Season_seasonFields_SeasonField as SeasonFields,
  Season_season_Season_seasonFields_SeasonField_field_Field_dams_Dam as SeasonFieldDam,
} from './types/season.graphql'

export const SEASON = gql`
  query Season($id: Int!, $fromDate: DateTime!, $isSatelliteImageryFlagOn: Boolean!) {
    season(id: $id) {
      id
      name
      startDate
      endDate
      description
      productionToMill
      millDeliveryType
      seasonFields {
        lots {
          id
          name
          size
          commercialName
          riceLot {
            id
            emergenceDate
            emergenceUpdateType
            isPlanetEnabled
            yield
            harvestDate
            harvestUpdateType
            isHarvested
            daysSinceEmergence
            indicators @include(if: $isSatelliteImageryFlagOn) {
              irrigation
              chlorophyll
              semaphore
            }
            estimatedYield {
              value
            }
          }
          location {
            coordinates
          }
          area {
            coordinates
          }
          variety {
            locales {
              es
              en
              pt
            }
            id
          }
          crop {
            id
            locales {
              es
              en
              pt
            }
          }
          irrigationWorker {
            id
          }
        }
        field {
          id
          name
          directions
          location {
            type
            coordinates
          }
          dams {
            id
            name
            indicators {
              waterSurfaceArea
              waterSurfaceVolume
              waterSurfacePercentage
            }
          }
          weather(fromDate: $fromDate) @include(if: $isSatelliteImageryFlagOn) {
            days {
              dateTime
              tempMax
              tempMin
              precipProb
              cloudCover
            }
          }
        }
      }
      updatedAt
    }
  }
`

export type { UpdateSeason, UpdateSeasonVariables } from './types/season.graphql'

export const UPDATE_SEASON = gql`
  mutation UpdateSeason($id: Int!, $updateSeasonDTO: UpdateSeasonInput!) {
    updateSeason(id: $id, updateSeasonDTO: $updateSeasonDTO) {
      season {
        id
        name
        startDate
        endDate
        description
        updatedAt
        productionToMill
        millDeliveryType
      }
    }
  }
`
